import { INBOX_TYPES } from 'dashboard/helper/inbox';

// Conteúdo ilustrativo das telas vazias: aparece desfocado atrás do convite para criar o
// primeiro registro. Usa exemplos brasileiros e os nomes fictícios aprovados.
export const assistantsList = [
  {
    account_id: 2,
    config: { product_name: 'Atendimento' },
    created_at: 1736033561,
    description:
      'Responde as dúvidas mais comuns do atendimento e encaminha para a equipe quando o assunto foge do combinado.',
    id: 4,
    name: 'Assistente de Atendimento',
  },
  {
    account_id: 3,
    config: { product_name: 'Pós-venda' },
    created_at: 1736033562,
    description:
      'Acompanha pedidos entregues, confirma dados de contato e registra pedidos de troca.',
    id: 5,
    name: 'Assistente de Pós-venda',
  },
  {
    account_id: 4,
    config: { product_name: 'Comercial' },
    created_at: 1736033563,
    description:
      'Faz a primeira qualificação do lead, entende a necessidade e agenda a conversa com o vendedor.',
    id: 6,
    name: 'Assistente Comercial',
  },
  {
    account_id: 5,
    config: { product_name: 'Financeiro' },
    created_at: 1736033564,
    description:
      'Esclarece dúvidas de cobrança, reenvia a segunda via e explica prazos de pagamento.',
    id: 7,
    name: 'Assistente Financeiro',
  },
  {
    account_id: 6,
    config: { product_name: 'Suporte técnico' },
    created_at: 1736033565,
    description:
      'Conduz o roteiro de verificação antes de abrir chamado e registra o que já foi testado.',
    id: 8,
    name: 'Assistente de Suporte',
  },
  {
    account_id: 8,
    config: { product_name: 'Agendamentos' },
    created_at: 1736033567,
    description:
      'Confirma horários, reagenda compromissos e avisa a equipe sobre cancelamentos.',
    id: 10,
    name: 'Assistente de Agenda',
  },
];

export const documentsList = [
  {
    account_id: 1,
    assistant: { id: 1, name: 'Assistente de Atendimento' },
    content:
      'Guia completo sobre como usar os filtros de conversa para organizar o atendimento.',
    created_at: 1736143272,
    external_link: 'https://talkvia.com.br/manual/filtros-de-conversa',
    id: 3059,
    name: 'Como usar os filtros de conversa | Manual Talkvia',
    status: 'available',
  },
  {
    account_id: 2,
    assistant: { id: 2, name: 'Assistente de Atendimento' },
    content:
      'Passo a passo para distribuir conversas automaticamente entre os atendentes.',
    created_at: 1736143273,
    external_link: 'https://talkvia.com.br/manual/distribuicao-automatica',
    id: 3060,
    name: 'Distribuição automática de conversas | Manual Talkvia',
    status: 'available',
  },
  {
    account_id: 3,
    assistant: { id: 3, name: 'Assistente de Pós-venda' },
    content:
      'Como manter o cadastro dos clientes organizado e o histórico sempre atualizado.',
    created_at: 1736143274,
    external_link: 'https://talkvia.com.br/manual/cadastro-de-clientes',
    id: 3061,
    name: 'Organizando o cadastro de clientes | Manual Talkvia',
    status: 'available',
  },
  {
    account_id: 4,
    assistant: { id: 4, name: 'Assistente Comercial' },
    content:
      'Como acompanhar propostas na esteira e prever o fechamento do mês.',
    created_at: 1736143275,
    external_link: 'https://talkvia.com.br/manual/esteira-de-propostas',
    id: 3062,
    name: 'Acompanhando a esteira de propostas | Manual Talkvia',
    status: 'available',
  },
  {
    account_id: 5,
    assistant: { id: 5, name: 'Assistente de Suporte' },
    content:
      'Como registrar, acompanhar e encerrar chamados sem perder o histórico.',
    created_at: 1736143276,
    external_link: 'https://talkvia.com.br/manual/chamados',
    id: 3063,
    name: 'Registro e acompanhamento de chamados | Manual Talkvia',
    status: 'available',
  },
  {
    account_id: 6,
    assistant: { id: 6, name: 'Assistente Financeiro' },
    content:
      'Como acompanhar os indicadores de atendimento e gerar relatórios para a equipe.',
    created_at: 1736143277,
    external_link: 'https://talkvia.com.br/manual/indicadores',
    id: 3064,
    name: 'Indicadores de atendimento | Manual Talkvia',
    status: 'available',
  },
];

export const responsesList = [
  {
    account_id: 1,
    answer:
      'O atendimento funciona de segunda a sexta, das 9h às 18h. Fora desse horário, sua mensagem fica registrada e respondemos no próximo dia útil.',
    created_at: 1736283330,
    id: 87,
    question: 'Qual é o horário de atendimento?',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'Atendimento' },
      created_at: 1736033280,
      description: 'Responde dúvidas gerais sobre o atendimento.',
      id: 1,
      name: 'Assistente de Atendimento',
    },
  },
  {
    account_id: 2,
    answer:
      'Assim que o pedido é despachado, enviamos o código de rastreio por aqui mesmo. Você também pode pedir a posição a qualquer momento.',
    created_at: 1736283340,
    id: 88,
    question: 'Como acompanho a entrega do meu pedido?',
    assistant: {
      account_id: 2,
      config: { product_name: 'Pós-venda' },
      created_at: 1736033281,
      description: 'Cuida de dúvidas sobre pedidos e entregas.',
      id: 2,
      name: 'Assistente de Pós-venda',
    },
  },
  {
    account_id: 3,
    answer:
      'Aceitamos Pix, cartão de crédito e boleto. No Pix a confirmação é na hora; no boleto, em até um dia útil.',
    created_at: 1736283350,
    id: 89,
    question: 'Quais formas de pagamento vocês aceitam?',
    assistant: {
      account_id: 3,
      config: { product_name: 'Financeiro' },
      created_at: 1736033282,
      description: 'Esclarece dúvidas de pagamento e cobrança.',
      id: 3,
      name: 'Assistente Financeiro',
    },
  },
  {
    account_id: 4,
    answer:
      'A segunda via pode ser enviada por aqui. Confirme o CPF ou CNPJ do cadastro e eu envio o boleto atualizado.',
    created_at: 1736283360,
    id: 90,
    question: 'Como peço a segunda via do boleto?',
    assistant: {
      account_id: 4,
      config: { product_name: 'Financeiro' },
      created_at: 1736033283,
      description: 'Resolve pedidos de segunda via e prazos.',
      id: 4,
      name: 'Assistente Financeiro',
    },
  },
  {
    account_id: 5,
    answer:
      'A troca pode ser solicitada em até 7 dias após o recebimento, com o produto sem uso e na embalagem original.',
    created_at: 1736283370,
    id: 91,
    question: 'Qual é o prazo para solicitar troca?',
    assistant: {
      account_id: 5,
      config: { product_name: 'Pós-venda' },
      created_at: 1736033284,
      description: 'Registra pedidos de troca e devolução.',
      id: 5,
      name: 'Assistente de Pós-venda',
    },
  },
  {
    account_id: 6,
    answer:
      'Posso agendar um horário com nosso time comercial. Me diga o melhor dia e período que eu confirmo a agenda.',
    created_at: 1736283380,
    id: 92,
    question: 'Consigo falar com um vendedor?',
    assistant: {
      account_id: 6,
      config: { product_name: 'Comercial' },
      created_at: 1736033285,
      description: 'Qualifica o lead e agenda a conversa comercial.',
      id: 6,
      name: 'Assistente Comercial',
    },
  },
];

export const inboxes = [
  {
    id: 7,
    name: 'Atendimento por e-mail',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'atendimento@empresa.com.br',
  },
  {
    id: 1,
    name: 'Chat do site',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'Facebook',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: 'SMS',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'WhatsApp Comercial',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+5519999990000',
  },
  {
    id: 8,
    name: 'Telegram',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'LINE',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'Integrações (API)',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: 'SMS simples',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+5519999990001',
  },
];

// Exemplos ilustrativos da tela vazia de ferramentas. Não são ferramentas reais
// da conta e nunca são executados; servem só para mostrar o formato do cartão.
export const customToolsList = [
  {
    id: 1,
    title: 'Consultar pedido',
    description:
      'Busca o andamento de um pedido pelo número informado pelo cliente.',
    auth_type: 'bearer',
    created_at: 1757000000,
    updated_at: 1757000000,
  },
  {
    id: 2,
    title: 'Segunda via do boleto',
    description:
      'Devolve o link do boleto em aberto a partir do CPF confirmado na conversa.',
    auth_type: 'api_key',
    created_at: 1756500000,
    updated_at: 1756900000,
  },
  {
    id: 3,
    title: 'Horário de atendimento',
    description: 'Informa os horários da unidade mais próxima do cliente.',
    auth_type: 'none',
    created_at: 1756000000,
    updated_at: 1756200000,
  },
];
